import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";

// Animated count-up number, triggered when scrolled into view.
export const CountUpStat = ({ value, suffix = "+", label, testId }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 1.6,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <div ref={ref} data-testid={testId} className="flex flex-col">
      <span className="font-playfair font-bold leading-none text-[var(--text-accent)] text-4xl md:text-5xl">
        {display}
        {suffix}
      </span>
      <span className="mt-2 font-inter text-[11px] md:text-xs uppercase tracking-[0.24em] text-[var(--text-muted)]">
        {label}
      </span>
    </div>
  );
};
